import colors from '@otomoro/styles/variables/colors.module.scss'

type Props = {
  theme?: 'light' | 'dark' | 'color'
}

export function TikTokIcon({ theme = 'color' }: Props) {
  if (theme === 'color') {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 64 64"
      >
        <g fillRule="evenodd">
          <path
            d="m48 64h-32a16.0007 16.0007 0 0 1 -16-16v-32a16.0007 16.0007 0 0 1 16-16h32a16 16 0 0 1 16 16v32a16 16 0 0 1 -16 16"
            fill="#2d0f1e"
          />
          <path
            d="m30 18h18a9.0006 9.0006 0 0 0 .92-17.954c-.306-.017-.609-.046-.92-.046h-32a16.0007 16.0007 0 0 0 -16 16v32a30.0007 30.0007 0 0 1 30-30"
            fill="#501432"
          />
          <path
            d="m48 32a16 16 0 1 0 16 16v-32a16 16 0 0 1 -16 16"
            fill="#000"
          />
          <path
            d="m34 14a1.9994 1.9994 0 0 1 2-2h4.229a2 2 0 0 1 1.961 1.609 7.9559 7.9559 0 0 0 7.81 6.391 1.9994 1.9994 0 0 1 2 2v4a1.9994 1.9994 0 0 1 -2 2 15.9169 15.9169 0 0 1 -8-2.143v16.143a13.9993 13.9993 0 1 1 -14-14 1.9994 1.9994 0 0 1 2 2v4a1.9994 1.9994 0 0 1 -2 2 6.0005 6.0005 0 1 0 6 6z"
            fill="#fe2c55"
          />
          <path
            d="m32 12a1.9994 1.9994 0 0 1 2-2h4.229a2 2 0 0 1 1.961 1.609 7.9559 7.9559 0 0 0 7.81 6.391 1.9994 1.9994 0 0 1 2 2v4a1.9994 1.9994 0 0 1 -2 2 15.9169 15.9169 0 0 1 -8-2.143v16.143a13.9993 13.9993 0 1 1 -14-14 1.9994 1.9994 0 0 1 2 2v4a1.9994 1.9994 0 0 1 -2 2 6.0005 6.0005 0 1 0 6 6z"
            fill="#25f4ee"
          />
          <path
            d="m22.876 45.124a6.0005 6.0005 0 0 0 11.124-3.124v-28a1.9994 1.9994 0 0 1 2-2h4.229c.017 0 .033 0 .049.001a7.9381 7.9381 0 0 0 3.173 4.577 7.9586 7.9586 0 0 0 6.549 3.422v4a1.9994 1.9994 0 0 1 -2 2 15.9169 15.9169 0 0 1 -8-2.143v16.143a14 14 0 0 1 -22.849 10.849 14.0007 14.0007 0 0 1 10.849-22.849v4a1.9994 1.9994 0 0 1 -2 2 6.0009 6.0009 0 0 0 -3.124 11.124z"
            fill="#fff"
          />
        </g>
      </svg>
    )
  }

  // Default light or dark versions (same as before)
  const fillColor = theme === 'dark' ? "#828282" : "#000000"

  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.18 7.15624C13.6285 7.15624 12.1901 6.66011 11.0165 5.81726V11.8993C11.0165 14.937 8.54528 17.4075 5.50826 17.4075C4.33466 17.4075 3.24591 17.0376 2.35157 16.4095C0.931342 15.4121 0 13.7627 0 11.8993C0 8.86153 2.47125 6.39028 5.50899 6.39028C5.76141 6.39028 6.00802 6.41131 6.25102 6.44395V7.15262V9.4991C6.016 9.42584 5.76794 9.38305 5.50899 9.38305C4.12213 9.38305 2.99349 10.5117 2.99349 11.8993C2.99349 12.8654 3.54186 13.7046 4.34264 14.1261C4.69153 14.3096 5.08829 14.4148 5.50971 14.4148C6.86466 14.4148 7.97008 13.3369 8.02085 11.9936L8.02303 0H11.0158C11.0158 0.259673 11.0412 0.512818 11.0862 0.759435C11.2972 1.89968 11.974 2.87816 12.9118 3.48963C13.5647 3.91541 14.3437 4.1642 15.1793 4.1642L15.18 7.15624Z"
        className="transition-all"
        fill={fillColor}
      />
    </svg>
  )
}
